<div class="form-panel-container">
    <form [formGroup]="formGroup">
        <div class="form-container" [ngClass]="{ readonly: _context?.mode === FormMode.Reading }">
            @if (_context.mode !== FormMode.Reading) {
                <div class="sms-buttons">
                    <button
                        mat-mini-fab
                        class="basic-button"
                        aria-label="Ouvrir le carnet d’adresses"
                        matTooltip="Ouvrir le carnet d’adresses"
                        matTooltipPosition="below"
                        (click)="displayContacts()">
                        <mat-icon>contact_mail</mat-icon>
                    </button>
                </div>
            }
            <div class="form-item name form-item-help">
                <mat-form-field class="with-info-icon">
                    <mat-label>Nom</mat-label>
                    <input matInput data-input-code type="text" formControlName="name" autocomplete="off" required />
                    @if (formGroupErrors?.name?.required && (formGroup.controls['name']?.dirty || formGroup.controls['name'].touched)) {
                        <mat-error data-input-title-error>Le champ 'Nom' est obligatoire</mat-error>
                    }
                </mat-form-field>
                <fa-icon
                    [icon]="faCircleInfo"
                    class="info-icon"
                    hubToolTip="Nom du modèle de SMS. Ce nom sera affiché dans les listes déroulantes de selection d'un modèle de SMS."
                    tooltipPosition="right"></fa-icon>
            </div>
            <div>
                <div class="form-item form-item-help">
                    <mat-form-field class="with-info-icon mat-form-field-recipients">
                        <mat-label>Destinataires</mat-label>
                        <mat-chip-grid #toChipList multiple [disabled]="_context.mode === FormMode.Reading" [formControl]="recipientsFormControl">
                            @for (item of sms.to; track $index) {
                                <mat-chip-row selectable="false" removable="true" (removed)="removeMobileNumber(item)">
                                    {{ item }}
                                    @if (_context.mode !== FormMode.Reading) {
                                        <mat-icon matChipRemove>cancel</mat-icon>
                                    }
                                </mat-chip-row>
                            }
                            <input
                                tabindex="2"
                                class="mobile-number-input"
                                [formControl]="recipientInputFormControl"
                                [matChipInputFor]="toChipList"
                                [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                                matChipInputAddOnBlur="true"
                                (matChipInputTokenEnd)="addMobileNumber($event)"
                                (paste)="pasteMobileNumbers($event)"
                                (contextmenu)="$event.preventDefault(); onChipListRightClick('to', $event)"
                                placeholder="Saisir un n° de téléphone" />
                        </mat-chip-grid>
                        @if (recipientsFormControl.hasError('maxRecipients')) {
                            <mat-error>Le champ destinataires est limité à 5 destinataires</mat-error>
                        }
                        @if (recipientInputFormControl.hasError('pattern') && (recipientInputFormControl?.dirty || recipientInputFormControl?.touched)) {
                            <span class="recipient-input-error">Le n° de téléphone est invalide</span>
                        }
                    </mat-form-field>
                    <fa-icon
                        [icon]="faCircleInfo"
                        class="info-icon"
                        hubToolTip="Ce champ permet de définir les destinataires du SMS.<br>Les n° de téléphone des destinataires peuvent être saisis manuellement ou en les sélectionnant à partir du carnet de contacts (icone situé dans le coin supérieur droit).<br>
                        Pour valider la saisie manuelle d'un n° de téléphone, cliquez sur <b>;</b> ou sur <b>Entrée</b>.<br><br>Il est également possible d'utiliser une <b>variable</b> faisant référence à un attribut de type <b>N° de téléphone</b>. Cette variable sera remplacée par la valeur de l'attribut correspondant au moment de l'envoi du mail.<br>Pour ajouter une variable, faites un clic droit sur le champ pour afficher la liste des variables disponibles."
                        tooltipPosition="right"></fa-icon>
                </div>
            </div>
            <div class="form-item form-item-help">
                <mat-form-field class="with-info-icon mat-form-field-content">
                    <mat-label>Contenu</mat-label>
                    <textarea
                        matInput
                        tabindex="3"
                        rows="6"
                        [formControl]="contentFormControl"
                        autocomplete="off"
                        (contextmenu)="$event.preventDefault(); onInputRightClick('content', $event)"></textarea>
                </mat-form-field>
                <fa-icon
                    [icon]="faCircleInfo"
                    class="info-icon"
                    hubToolTip="Ce champ permet de définir le contenu du SMS.<br>Il est possible d'utiliser des <b>variables</b> faisant référence à des attributs du dossier. Ces variables seront remplacées par la valeur de l'attribut correspondant au moment de l'envoi du mail.<br>Pour ajouter une variable, faites un clic droit sur le champ pour afficher la liste des variables disponibles.<br><br>Le contenu d'un SMS est limité à 160 caractères et le nombre de SMS qu'il est possible d'envoyer en un seul envoi est de 10. Pour vous aider à respecter cette limite, une barre de progression est affichée en bas du champ.Toutefois il ne s’agit que d’une estimation qui ne prend pas en compte la taille réelle des caractères unicode et qui ne prend pas en compte la taille des variables après publipostage."
                    tooltipPosition="right"></fa-icon>
                <div class="progress">
                    <div #progressBar class="progress-bar"></div>
                </div>
                <p #charsCounter class="chars-counter">&nbsp;</p>
            </div>

            <app-template-context-menu
                [ngStyle]="getContextMenuStyle()"
                [contextMenuItems]="contextMenuItems"
                (onContextMenuItemClick)="handleMenuItemClick($event)"
                (onClosed)="CloseContextMenu()"></app-template-context-menu>
        </div>
    </form>
    <div class="buttons-container">
        <button mat-stroked-button class="accent-button" [disabled]="formGroup.disabled" [ngClass]="{ disabled: formGroup.disabled }" (click)="cancel()">Annuler</button>
        <button
            mat-raised-button
            class="accent-button"
            [disabled]="formGroup.disabled || formGroup.invalid || recipientsFormControl.invalid"
            [ngClass]="{ disabled: formGroup.invalid || formGroup.disabled }"
            (click)="manualSave()">
            Enregistrer
        </button>
    </div>
</div>
